export default "__VITE_ASSET__ZmS6bF0b__"